export default [
   {
      "daily":{
         "all":[
            {
               "date":0,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":1,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":2,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":3,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":4,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":5,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":6,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":7,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":8,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":9,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":10,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":11,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":12,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":13,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":14,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":15,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":16,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":17,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":18,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":19,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":20,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":21,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":22,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            }
         ],
         "asia":[
            {
               "date":10,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":17,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":19,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":21,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            }
         ],
         "au":[
            {
               "date":0,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":1,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":2,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":3,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":4,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":5,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":6,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":7,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":8,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":9,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":10,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":11,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":12,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":13,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":14,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":15,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":16,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":17,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":18,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":19,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":20,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":21,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":22,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            }
         ],
         "eu":[
            {
               "date":0,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":1,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":2,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":3,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":4,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":5,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":6,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":7,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":8,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":9,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":10,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":11,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":12,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":13,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":14,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":15,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":16,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":17,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":18,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":19,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":20,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":21,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":22,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            }
         ],
         "dk":[
            {
               "date":0,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":1,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":2,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":3,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":4,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":5,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":6,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":7,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":8,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":9,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":10,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":11,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":12,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":13,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":14,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":15,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":16,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":17,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":18,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":19,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            }
         ],
         "fr":[
            {
               "date":0,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":1,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":2,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":3,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":4,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":5,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":6,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":7,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":8,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":9,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":10,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":11,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":12,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":13,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":14,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":15,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":16,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":17,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":18,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":19,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":20,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":21,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":22,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            }
         ],
         "hk":[
            {
               "date":0,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":1,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":2,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":3,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":4,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":5,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":6,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":7,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":8,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":9,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":10,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":11,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":12,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":13,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":14,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":15,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":16,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":17,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":18,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":19,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            }
         ],
         "uk":[
            {
               "date":0,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":1,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":2,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":3,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":4,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":5,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":6,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":7,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":8,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":9,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":10,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":11,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":12,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":13,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":14,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":15,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":16,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":17,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":18,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":19,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":20,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":21,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":22,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            }
         ],
         "us":[
            {
               "date":0,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":1,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":2,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":3,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":4,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":5,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":6,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":7,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":8,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":9,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":10,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":11,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":12,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":13,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":14,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":15,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":16,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":17,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":18,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":19,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":20,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":21,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            },
            {
               "date":22,
               "total_orders":2,
               "total_sales":"100",
               "total_items":"5"
            }
         ]
      },
      "yesterday":{
         "all":[
            {
               "date":0,
               "total_orders":18,
               "total_sales":"2565.54146200",
               "total_items":"39.0000"
            },
            {
               "date":1,
               "total_orders":15,
               "total_sales":"2716.70774900",
               "total_items":"35.0000"
            },
            {
               "date":2,
               "total_orders":14,
               "total_sales":"3120.90070600",
               "total_items":"40.0000"
            },
            {
               "date":3,
               "total_orders":14,
               "total_sales":"4286.51177900",
               "total_items":"26.0000"
            },
            {
               "date":4,
               "total_orders":13,
               "total_sales":"3377.82119900",
               "total_items":"28.0000"
            },
            {
               "date":5,
               "total_orders":18,
               "total_sales":"2695.71395700",
               "total_items":"28.0000"
            },
            {
               "date":6,
               "total_orders":21,
               "total_sales":"3746.96672300",
               "total_items":"42.0000"
            },
            {
               "date":7,
               "total_orders":17,
               "total_sales":"2508.63903800",
               "total_items":"26.0000"
            },
            {
               "date":8,
               "total_orders":23,
               "total_sales":"3264.89055600",
               "total_items":"35.0000"
            },
            {
               "date":9,
               "total_orders":30,
               "total_sales":"3743.69490000",
               "total_items":"42.0000"
            },
            {
               "date":10,
               "total_orders":59,
               "total_sales":"9349.15630600",
               "total_items":"129.0000"
            },
            {
               "date":11,
               "total_orders":28,
               "total_sales":"3728.44910500",
               "total_items":"40.0000"
            },
            {
               "date":12,
               "total_orders":47,
               "total_sales":"6869.22882500",
               "total_items":"89.0000"
            },
            {
               "date":13,
               "total_orders":65,
               "total_sales":"8726.33063200",
               "total_items":"103.0000"
            },
            {
               "date":14,
               "total_orders":42,
               "total_sales":"4501.85740100",
               "total_items":"65.0000"
            },
            {
               "date":15,
               "total_orders":31,
               "total_sales":"5380.10575200",
               "total_items":"61.0000"
            },
            {
               "date":16,
               "total_orders":56,
               "total_sales":"8862.92976700",
               "total_items":"96.0000"
            },
            {
               "date":17,
               "total_orders":51,
               "total_sales":"6720.24866500",
               "total_items":"119.0000"
            },
            {
               "date":18,
               "total_orders":74,
               "total_sales":"8094.52038200",
               "total_items":"110.0000"
            },
            {
               "date":19,
               "total_orders":45,
               "total_sales":"6774.59511100",
               "total_items":"85.0000"
            },
            {
               "date":20,
               "total_orders":49,
               "total_sales":"6950.60888600",
               "total_items":"94.0000"
            },
            {
               "date":21,
               "total_orders":48,
               "total_sales":"15749.85304800",
               "total_items":"84.0000"
            },
            {
               "date":22,
               "total_orders":56,
               "total_sales":"6873.37523000",
               "total_items":"93.0000"
            },
            {
               "date":23,
               "total_orders":36,
               "total_sales":"5997.96001400",
               "total_items":"68.0000"
            }
         ],
         "asia":[
            {
               "date":8,
               "total_orders":1,
               "total_sales":"22.61000000",
               "total_items":"1.0000"
            },
            {
               "date":16,
               "total_orders":2,
               "total_sales":"302.26000000",
               "total_items":"3.0000"
            },
            {
               "date":19,
               "total_orders":2,
               "total_sales":"158.27000000",
               "total_items":"5.0000"
            },
            {
               "date":20,
               "total_orders":1,
               "total_sales":"169.57500000",
               "total_items":"4.0000"
            },
            {
               "date":22,
               "total_orders":1,
               "total_sales":"94.01000000",
               "total_items":"1.0000"
            },
            {
               "date":23,
               "total_orders":1,
               "total_sales":"146.37000000",
               "total_items":"4.0000"
            }
         ],
         "au":[
            {
               "date":1,
               "total_orders":3,
               "total_sales":"365.12460000",
               "total_items":"3.0000"
            },
            {
               "date":2,
               "total_orders":1,
               "total_sales":"102.85200000",
               "total_items":"1.0000"
            },
            {
               "date":3,
               "total_orders":1,
               "total_sales":"46.28340000",
               "total_items":"1.0000"
            },
            {
               "date":5,
               "total_orders":1,
               "total_sales":"87.42420000",
               "total_items":"1.0000"
            },
            {
               "date":6,
               "total_orders":1,
               "total_sales":"53.14020000",
               "total_items":"1.0000"
            },
            {
               "date":7,
               "total_orders":3,
               "total_sales":"740.53440000",
               "total_items":"3.0000"
            },
            {
               "date":8,
               "total_orders":1,
               "total_sales":"219.98900000",
               "total_items":"2.0000"
            },
            {
               "date":9,
               "total_orders":2,
               "total_sales":"141.13580000",
               "total_items":"3.0000"
            },
            {
               "date":10,
               "total_orders":3,
               "total_sales":"530.83060000",
               "total_items":"6.0000"
            },
            {
               "date":11,
               "total_orders":1,
               "total_sales":"238.84520000",
               "total_items":"2.0000"
            },
            {
               "date":12,
               "total_orders":1,
               "total_sales":"121.70820000",
               "total_items":"1.0000"
            },
            {
               "date":13,
               "total_orders":3,
               "total_sales":"877.67040000",
               "total_items":"17.0000"
            },
            {
               "date":16,
               "total_orders":2,
               "total_sales":"237.70240000",
               "total_items":"2.0000"
            },
            {
               "date":18,
               "total_orders":1,
               "total_sales":"102.85200000",
               "total_items":"1.0000"
            },
            {
               "date":21,
               "total_orders":1,
               "total_sales":"38.85520000",
               "total_items":"1.0000"
            },
            {
               "date":22,
               "total_orders":1,
               "total_sales":"147.42120000",
               "total_items":"2.0000"
            },
            {
               "date":23,
               "total_orders":3,
               "total_sales":"997.09300000",
               "total_items":"4.0000"
            }
         ],
         "eu":[
            {
               "date":0,
               "total_orders":1,
               "total_sales":"93.22500000",
               "total_items":"2.0000"
            },
            {
               "date":6,
               "total_orders":2,
               "total_sales":"350.86500000",
               "total_items":"4.0000"
            },
            {
               "date":8,
               "total_orders":1,
               "total_sales":"100.00500000",
               "total_items":"1.0000"
            },
            {
               "date":9,
               "total_orders":3,
               "total_sales":"375.44250000",
               "total_items":"3.0000"
            },
            {
               "date":10,
               "total_orders":7,
               "total_sales":"898.35000000",
               "total_items":"11.0000"
            },
            {
               "date":11,
               "total_orders":4,
               "total_sales":"611.04750000",
               "total_items":"5.0000"
            },
            {
               "date":12,
               "total_orders":3,
               "total_sales":"482.22750000",
               "total_items":"5.0000"
            },
            {
               "date":13,
               "total_orders":7,
               "total_sales":"712.74750000",
               "total_items":"9.0000"
            },
            {
               "date":14,
               "total_orders":5,
               "total_sales":"650.45625000",
               "total_items":"7.0000"
            },
            {
               "date":16,
               "total_orders":9,
               "total_sales":"1337.49907500",
               "total_items":"20.0000"
            },
            {
               "date":17,
               "total_orders":10,
               "total_sales":"1686.52500000",
               "total_items":"28.0000"
            },
            {
               "date":18,
               "total_orders":7,
               "total_sales":"969.54000000",
               "total_items":"18.0000"
            },
            {
               "date":19,
               "total_orders":8,
               "total_sales":"2734.03500000",
               "total_items":"19.0000"
            },
            {
               "date":20,
               "total_orders":10,
               "total_sales":"1471.68375000",
               "total_items":"32.0000"
            },
            {
               "date":21,
               "total_orders":9,
               "total_sales":"1005.98250000",
               "total_items":"14.0000"
            },
            {
               "date":22,
               "total_orders":10,
               "total_sales":"1400.91750000",
               "total_items":"24.0000"
            },
            {
               "date":23,
               "total_orders":3,
               "total_sales":"428.83500000",
               "total_items":"4.0000"
            }
         ],
         "dk":[
            {
               "date":1,
               "total_orders":1,
               "total_sales":"154.80630000",
               "total_items":"1.0000"
            },
            {
               "date":2,
               "total_orders":2,
               "total_sales":"842.17590000",
               "total_items":"9.0000"
            },
            {
               "date":3,
               "total_orders":1,
               "total_sales":"169.62030000",
               "total_items":"2.0000"
            },
            {
               "date":4,
               "total_orders":2,
               "total_sales":"194.80410000",
               "total_items":"2.0000"
            },
            {
               "date":5,
               "total_orders":2,
               "total_sales":"120.73410000",
               "total_items":"2.0000"
            },
            {
               "date":8,
               "total_orders":2,
               "total_sales":"385.90470000",
               "total_items":"3.0000"
            },
            {
               "date":9,
               "total_orders":2,
               "total_sales":"65.18160000",
               "total_items":"2.0000"
            },
            {
               "date":10,
               "total_orders":2,
               "total_sales":"146.65860000",
               "total_items":"2.0000"
            },
            {
               "date":11,
               "total_orders":1,
               "total_sales":"111.84570000",
               "total_items":"2.0000"
            },
            {
               "date":12,
               "total_orders":1,
               "total_sales":"21.48030000",
               "total_items":"1.0000"
            },
            {
               "date":13,
               "total_orders":4,
               "total_sales":"397.75590000",
               "total_items":"4.0000"
            },
            {
               "date":14,
               "total_orders":1,
               "total_sales":"31.10940000",
               "total_items":"2.0000"
            },
            {
               "date":15,
               "total_orders":1,
               "total_sales":"308.87190000",
               "total_items":"2.0000"
            },
            {
               "date":16,
               "total_orders":2,
               "total_sales":"433.30950000",
               "total_items":"6.0000"
            },
            {
               "date":18,
               "total_orders":1,
               "total_sales":"65.92230000",
               "total_items":"1.0000"
            }
         ],
         "fr":[
            {
               "date":4,
               "total_orders":2,
               "total_sales":"733.08750000",
               "total_items":"5.0000"
            },
            {
               "date":5,
               "total_orders":3,
               "total_sales":"333.34717500",
               "total_items":"4.0000"
            },
            {
               "date":6,
               "total_orders":2,
               "total_sales":"363.57750000",
               "total_items":"4.0000"
            },
            {
               "date":7,
               "total_orders":3,
               "total_sales":"314.42250000",
               "total_items":"3.0000"
            },
            {
               "date":8,
               "total_orders":5,
               "total_sales":"494.94000000",
               "total_items":"7.0000"
            },
            {
               "date":9,
               "total_orders":4,
               "total_sales":"476.29500000",
               "total_items":"5.0000"
            },
            {
               "date":10,
               "total_orders":8,
               "total_sales":"1047.51000000",
               "total_items":"10.0000"
            },
            {
               "date":11,
               "total_orders":4,
               "total_sales":"302.55750000",
               "total_items":"8.0000"
            },
            {
               "date":12,
               "total_orders":5,
               "total_sales":"1175.20282500",
               "total_items":"10.0000"
            },
            {
               "date":13,
               "total_orders":5,
               "total_sales":"839.87250000",
               "total_items":"7.0000"
            },
            {
               "date":14,
               "total_orders":2,
               "total_sales":"415.27500000",
               "total_items":"5.0000"
            },
            {
               "date":15,
               "total_orders":5,
               "total_sales":"888.18000000",
               "total_items":"7.0000"
            },
            {
               "date":16,
               "total_orders":5,
               "total_sales":"809.36250000",
               "total_items":"7.0000"
            },
            {
               "date":17,
               "total_orders":5,
               "total_sales":"865.29750000",
               "total_items":"6.0000"
            },
            {
               "date":18,
               "total_orders":2,
               "total_sales":"229.67250000",
               "total_items":"7.0000"
            },
            {
               "date":19,
               "total_orders":1,
               "total_sales":"111.02250000",
               "total_items":"1.0000"
            },
            {
               "date":20,
               "total_orders":8,
               "total_sales":"1225.48500000",
               "total_items":"12.0000"
            },
            {
               "date":21,
               "total_orders":9,
               "total_sales":"994.96500000",
               "total_items":"11.0000"
            },
            {
               "date":22,
               "total_orders":4,
               "total_sales":"668.67750000",
               "total_items":"7.0000"
            },
            {
               "date":23,
               "total_orders":1,
               "total_sales":"408.21532500",
               "total_items":"4.0000"
            }
         ],
         "hk":[
            {
               "date":0,
               "total_orders":1,
               "total_sales":"29.40000000",
               "total_items":"1.0000"
            },
            {
               "date":2,
               "total_orders":3,
               "total_sales":"769.49600000",
               "total_items":"16.0000"
            },
            {
               "date":3,
               "total_orders":5,
               "total_sales":"707.36400000",
               "total_items":"5.0000"
            },
            {
               "date":4,
               "total_orders":4,
               "total_sales":"643.37000000",
               "total_items":"9.0000"
            },
            {
               "date":5,
               "total_orders":5,
               "total_sales":"718.53600000",
               "total_items":"7.0000"
            },
            {
               "date":6,
               "total_orders":4,
               "total_sales":"469.71400000",
               "total_items":"5.0000"
            },
            {
               "date":8,
               "total_orders":1,
               "total_sales":"234.22000000",
               "total_items":"2.0000"
            },
            {
               "date":9,
               "total_orders":2,
               "total_sales":"204.82000000",
               "total_items":"2.0000"
            },
            {
               "date":10,
               "total_orders":1,
               "total_sales":"141.61000000",
               "total_items":"1.0000"
            },
            {
               "date":12,
               "total_orders":1,
               "total_sales":"234.22000000",
               "total_items":"2.0000"
            },
            {
               "date":13,
               "total_orders":5,
               "total_sales":"1437.85600000",
               "total_items":"10.0000"
            },
            {
               "date":14,
               "total_orders":5,
               "total_sales":"678.25800000",
               "total_items":"7.0000"
            },
            {
               "date":15,
               "total_orders":4,
               "total_sales":"894.54400000",
               "total_items":"8.0000"
            },
            {
               "date":16,
               "total_orders":4,
               "total_sales":"506.46400000",
               "total_items":"7.0000"
            },
            {
               "date":17,
               "total_orders":1,
               "total_sales":"13.03400000",
               "total_items":"1.0000"
            },
            {
               "date":18,
               "total_orders":1,
               "total_sales":"29.40000000",
               "total_items":"1.0000"
            },
            {
               "date":19,
               "total_orders":1,
               "total_sales":"120.34400000",
               "total_items":"3.0000"
            }
         ],
         "uk":[
            {
               "date":0,
               "total_orders":11,
               "total_sales":"1799.50000000",
               "total_items":"24.0000"
            },
            {
               "date":1,
               "total_orders":5,
               "total_sales":"1048.64000000",
               "total_items":"15.0000"
            },
            {
               "date":2,
               "total_orders":2,
               "total_sales":"446.00000000",
               "total_items":"5.0000"
            },
            {
               "date":3,
               "total_orders":4,
               "total_sales":"764.15000000",
               "total_items":"5.0000"
            },
            {
               "date":4,
               "total_orders":2,
               "total_sales":"264.00000000",
               "total_items":"5.0000"
            },
            {
               "date":5,
               "total_orders":1,
               "total_sales":"60.00000000",
               "total_items":"1.0000"
            },
            {
               "date":6,
               "total_orders":7,
               "total_sales":"1513.51000000",
               "total_items":"18.0000"
            },
            {
               "date":7,
               "total_orders":9,
               "total_sales":"987.53000000",
               "total_items":"14.0000"
            },
            {
               "date":8,
               "total_orders":10,
               "total_sales":"1201.27000000",
               "total_items":"15.0000"
            },
            {
               "date":9,
               "total_orders":17,
               "total_sales":"2480.82000000",
               "total_items":"27.0000"
            },
            {
               "date":10,
               "total_orders":37,
               "total_sales":"6417.11000000",
               "total_items":"96.0000"
            },
            {
               "date":11,
               "total_orders":16,
               "total_sales":"1943.33000000",
               "total_items":"21.0000"
            },
            {
               "date":12,
               "total_orders":36,
               "total_sales":"4834.39000000",
               "total_items":"70.0000"
            },
            {
               "date":13,
               "total_orders":39,
               "total_sales":"4369.50000000",
               "total_items":"54.0000"
            },
            {
               "date":14,
               "total_orders":24,
               "total_sales":"2313.50000000",
               "total_items":"38.0000"
            },
            {
               "date":15,
               "total_orders":18,
               "total_sales":"2935.67000000",
               "total_items":"40.0000"
            },
            {
               "date":16,
               "total_orders":26,
               "total_sales":"3736.00000000",
               "total_items":"42.0000"
            },
            {
               "date":17,
               "total_orders":31,
               "total_sales":"3299.18000000",
               "total_items":"70.0000"
            },
            {
               "date":18,
               "total_orders":57,
               "total_sales":"6304.37000000",
               "total_items":"76.0000"
            },
            {
               "date":19,
               "total_orders":27,
               "total_sales":"3023.01000000",
               "total_items":"45.0000"
            },
            {
               "date":20,
               "total_orders":25,
               "total_sales":"3248.00000000",
               "total_items":"36.0000"
            },
            {
               "date":21,
               "total_orders":24,
               "total_sales":"12740.00000000",
               "total_items":"49.0000"
            },
            {
               "date":22,
               "total_orders":37,
               "total_sales":"4167.63000000",
               "total_items":"51.0000"
            },
            {
               "date":23,
               "total_orders":21,
               "total_sales":"2105.50000000",
               "total_items":"40.0000"
            }
         ],
         "us":[
            {
               "date":0,
               "total_orders":5,
               "total_sales":"643.41646200",
               "total_items":"12.0000"
            },
            {
               "date":1,
               "total_orders":6,
               "total_sales":"1148.13684900",
               "total_items":"16.0000"
            },
            {
               "date":2,
               "total_orders":6,
               "total_sales":"960.37680600",
               "total_items":"9.0000"
            },
            {
               "date":3,
               "total_orders":3,
               "total_sales":"2599.09407900",
               "total_items":"13.0000"
            },
            {
               "date":4,
               "total_orders":3,
               "total_sales":"1542.55959900",
               "total_items":"7.0000"
            },
            {
               "date":5,
               "total_orders":6,
               "total_sales":"1375.67248200",
               "total_items":"13.0000"
            },
            {
               "date":6,
               "total_orders":5,
               "total_sales":"996.16002300",
               "total_items":"10.0000"
            },
            {
               "date":7,
               "total_orders":2,
               "total_sales":"466.15213800",
               "total_items":"6.0000"
            },
            {
               "date":8,
               "total_orders":2,
               "total_sales":"605.95185600",
               "total_items":"4.0000"
            },
            {
               "date":10,
               "total_orders":1,
               "total_sales":"167.08710600",
               "total_items":"3.0000"
            },
            {
               "date":11,
               "total_orders":2,
               "total_sales":"520.82320500",
               "total_items":"2.0000"
            },
            {
               "date":13,
               "total_orders":2,
               "total_sales":"90.92833200",
               "total_items":"2.0000"
            },
            {
               "date":14,
               "total_orders":5,
               "total_sales":"413.25875100",
               "total_items":"6.0000"
            },
            {
               "date":15,
               "total_orders":3,
               "total_sales":"352.83985200",
               "total_items":"4.0000"
            },
            {
               "date":16,
               "total_orders":6,
               "total_sales":"1500.33229200",
               "total_items":"9.0000"
            },
            {
               "date":17,
               "total_orders":4,
               "total_sales":"856.21216500",
               "total_items":"14.0000"
            },
            {
               "date":18,
               "total_orders":5,
               "total_sales":"392.76358200",
               "total_items":"6.0000"
            },
            {
               "date":19,
               "total_orders":6,
               "total_sales":"627.91361100",
               "total_items":"12.0000"
            },
            {
               "date":20,
               "total_orders":5,
               "total_sales":"835.86513600",
               "total_items":"10.0000"
            },
            {
               "date":21,
               "total_orders":5,
               "total_sales":"970.05034800",
               "total_items":"9.0000"
            },
            {
               "date":22,
               "total_orders":3,
               "total_sales":"394.71903000",
               "total_items":"8.0000"
            },
            {
               "date":23,
               "total_orders":7,
               "total_sales":"1911.94668900",
               "total_items":"12.0000"
            }
         ]
      },
      "monthly":{
         "all":[
            {
               "date":"2020-01-01",
               "total_orders":"300",
               "total_sales":"900",
               "total_items":"500"
            },
            {
               "date":"2020-01-02",
               "total_orders":"300",
               "total_sales":"900",
               "total_items":"500"
            },
            {
               "date":"2020-01-03",
               "total_orders":"300",
               "total_sales":"900",
               "total_items":"500"
            },
            {
               "date":"2020-01-04",
               "total_orders":"300",
               "total_sales":"900",
               "total_items":"500"
            },
            {
               "date":"2020-01-05",
               "total_orders":"300",
               "total_sales":"900",
               "total_items":"500"
            },
            {
               "date":"2020-01-06",
               "total_orders":"300",
               "total_sales":"900",
               "total_items":"500"
            },
            {
               "date":"2020-01-07",
               "total_orders":"300",
               "total_sales":"900",
               "total_items":"500"
            },
            {
               "date":"2020-01-08",
               "total_orders":"300",
               "total_sales":"900",
               "total_items":"500"
            },
            {
               "date":"2020-01-09",
               "total_orders":"300",
               "total_sales":"900",
               "total_items":"500"
            },
            {
               "date":"2020-01-10",
               "total_orders":"300",
               "total_sales":"900",
               "total_items":"500"
            },
            {
               "date":"2020-01-11",
               "total_orders":"300",
               "total_sales":"900",
               "total_items":"500"
            }
         ],
         "asia":[
            {
               "date":"2020-01-01",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-02",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-03",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-04",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-05",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-06",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-07",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-08",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-09",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-10",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-11",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            }
         ],
         "au":[
            {
               "date":"2020-01-01",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-02",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-03",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-04",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-05",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-06",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-07",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-08",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-09",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-10",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-11",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            }
         ],
         "eu":[
            {
               "date":"2020-01-01",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-02",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-03",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-04",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-05",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-06",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-07",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-08",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-09",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-10",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-11",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            }
         ],
         "dk":[
            {
               "date":"2020-01-01",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-02",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-03",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-04",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-05",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-06",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-07",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-08",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-09",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-10",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-11",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            }
         ],
         "fr":[
            {
               "date":"2020-01-01",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-02",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-03",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-04",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-05",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-06",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-07",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-08",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-09",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-10",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-11",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            }
         ],
         "hk":[
            {
               "date":"2020-01-01",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-02",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-03",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-04",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-05",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-06",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-07",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-08",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-09",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-10",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-11",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            }
         ],
         "uk":[
            {
               "date":"2020-01-01",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-02",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-03",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-04",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-05",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-06",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-07",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-08",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-09",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-10",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-11",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            }
         ],
         "us":[
            {
               "date":"2020-01-01",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-02",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-03",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-04",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-05",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-06",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-07",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-08",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-09",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-10",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            },
            {
               "date":"2020-01-11",
               "total_orders":"20",
               "total_sales":"500",
               "total_items":"20"
            }
         ]
      },
      "yearly":{
         "all":[
            {
               "date":"2020-01-01",
               "total_orders":"3000",
               "total_sales":"100000",
               "total_items":"3500"
            }
         ],
         "asia":[
            {
               "date":"2020-01-01",
               "total_orders":"200",
               "total_sales":"5000",
               "total_items":"200"
            }
         ],
         "au":[
            {
               "date":"2020-01-01",
               "total_orders":"200",
               "total_sales":"5000",
               "total_items":"200"
            }
         ],
         "eu":[
            {
               "date":"2020-01-01",
               "total_orders":"200",
               "total_sales":"5000",
               "total_items":"200"
            }
         ],
         "dk":[
            {
               "date":"2020-01-01",
               "total_orders":"200",
               "total_sales":"5000",
               "total_items":"200"
            }
         ],
         "fr":[
            {
               "date":"2020-01-01",
               "total_orders":"200",
               "total_sales":"5000",
               "total_items":"200"
            }
         ],
         "hk":[
            {
               "date":"2020-01-01",
               "total_orders":"200",
               "total_sales":"5000",
               "total_items":"200"
            }
         ],
         "uk":[
            {
               "date":"2020-01-01",
               "total_orders":"200",
               "total_sales":"5000",
               "total_items":"200"
            }
         ],
         "us":[
            {
               "date":"2020-01-01",
               "total_orders":"200",
               "total_sales":"5000",
               "total_items":"200"
            }
         ]
      },
      "totals":{
         "yearly":{
            "total_sales":100000,
            "total_items":3500,
            "total_orders":3000
         },
         "monthly":{
            "total_sales":100000,
            "total_items":3500,
            "total_orders":3000
         },
         "yesterdays":{
            "total_sales":950,
            "total_items":500,
            "total_orders":300
         },
         "daily":{
            "total_sales":1000,
            "total_items":502,
            "total_orders":301
         }
      }
   }
]
